import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  key: 1,
  id: "frame",
  class: "frame-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_config_provider = _resolveComponent("el-config-provider");
  return _openBlock(), _createBlock(_component_el_config_provider, {
    locale: _ctx.currentLang
  }, {
    default: _withCtx(() => [_ctx.route.name && _ctx.initSys ? (_openBlock(), _createBlock(_component_router_view, {
      key: 0
    })) : (_openBlock(), _createElementBlock("section", _hoisted_1))]),
    _: 1
  }, 8, ["locale"]);
}